import {
  GET_EXCO_KECAMATAN,
  GET_EXCO_KECAMATAN_SUCCESS,
  GET_EXCO_KECAMATAN_FAIL,
} from "./actionTypes";
import { API } from "../../API/api";

export const getTableKecamatan = (param,page,search,sort,sortType,filterProv,filterCities) => (dispatch) => {
  dispatch({
    type: GET_EXCO_KECAMATAN,
  });

  const request = API.getTableExco(param,page,search,sort,sortType,filterProv,filterCities);
  return request.then(
    (response) => dispatch(getTableKecamatanSuccess(response.data)),
    (err) => dispatch(getTableKecamatanFail(err))
  );
};

export const getTableKecamatanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_KECAMATAN_SUCCESS,
    payload: data,
  });
};

export const getTableKecamatanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_KECAMATAN_FAIL,
    payload: data,
  });
};
